import script from "./HomeWorldIntel.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeWorldIntel.vue?vue&type=script&setup=true&lang=js"

import "./HomeWorldIntel.vue?vue&type=style&index=0&id=d3b9c880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b9c880"]])

export default __exports__